import { createReducer, on, Action } from '@ngrx/store';
import { EntityState, EntityAdapter, createEntityAdapter } from '@ngrx/entity';

import * as NoteActions from './note.actions';
import { NoteEntity } from './note.models';
import { INote } from '@appgen-health-crm/api-interfaces';

export const NOTE_FEATURE_KEY = 'note';

export interface State extends EntityState<NoteEntity> {
  selectedId?: string | number; // which Note record has been selected
  loaded: boolean; // has the Note list been loaded
  creating: boolean;
  error?: string | null; // last none error (if any)
  appointmentNotes: INote[];
}

export interface NotePartialState {
  readonly [NOTE_FEATURE_KEY]: State;
}

export function selectNoteId(note: NoteEntity): string {
  //In this case this would be optional since primary key is id
  return note._id;
}

export const noteAdapter: EntityAdapter<NoteEntity> =
  createEntityAdapter<NoteEntity>({
    selectId: selectNoteId
  });

export const initialState: State = noteAdapter.getInitialState({
  // set initial required properties
  loaded: false,
  creating: false,
  totalCount: 0,
  appointmentNotes: []
});

const noteReducer = createReducer(
  initialState,
  on(NoteActions.loadNotes, state => {
    return noteAdapter.setAll([], { ...state, loaded: false, error: null });
  }),
  on(NoteActions.loadNotesSuccess, (state, { notes }) =>
    noteAdapter.upsertMany(notes ?? [], {
      ...state,
      loaded: true
    })
  ),
  on(NoteActions.loadNotesFailure, (state, { error }) => ({ ...state, error })),

  on(NoteActions.loadAppointmentNotes, state => ({
    ...state,
    appointmentNotes: []
  })),
  on(NoteActions.loadAppointmentNotesSuccess, (state, { notes }) => ({
    ...state,
    appointmentNotes: notes
  })),
  on(NoteActions.loadAppointmentNotesFailure, (state, { error }) => ({
    ...state,
    error
  })),
  on(NoteActions.upsertNote, state => ({
    ...state,
    creating: true,
    error: null
  })),
  on(NoteActions.upsertNoteSuccess, (state, { note, updateAppointmentNotes }) =>
    noteAdapter.upsertOne(note, {
      ...state,
      appointmentNotes: [note],
      creating: false
    })
  ),
  on(NoteActions.upsertNoteFailure, (state, { error }) => ({
    ...state,
    creating: false,
    error
  })),
  on(NoteActions.clearAppointmentNotes, state => ({
    ...state,
    selectedId: null,
    appointmentNotes: []
  }))
);

export function reducer(state: State | undefined, action: Action) {
  return noteReducer(state, action);
}
